module.exports = __webpack_public_path__ + "static/media/loc1_img13.a068c561.jpg";